import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { CommonService } from '../../../../services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-eap-amendments-view-modal',
  templateUrl: './eap-amendments-view-modal.component.html',
  styleUrls: ['./eap-amendments-view-modal.component.scss']
})
export class EapAmendmentsViewModalComponent implements OnInit {
  // File upload
  formData: FormData;
  amdTypeOptions = [];
  PatientList = [];
  amemdmentsForm: UntypedFormGroup;
  columnDefs;
  gridApi: GridApi;
  rowData;
  context;
  gridOptions;
  frameworkComponents;
  loadGrid = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  ApplicationID: any;
  userType: string = "";
  myDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService
  ) {

  }


  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.heading === 'Add') { //Add mode
      this.content.id = this.commonService.getUniqueId();
    }
    this.userType = this.userService.getUserType();
    this.amemdmentsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      TYPE: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      PATIENT_ID: new UntypedFormControl(null),
      NOTES: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(0),
    });
    this.GetMasterDropdownData();

    if (this.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();

    }
    else if (this.heading === 'View') { //View mode
      this.getRecordFprEdit();
      this.amemdmentsForm.disable();
    }
  }

  deleteRow() {

  }
  GetMasterDropdownData() {
    this.summaryService.getScreenDataForEdit("api/EAPAmendments/GetMasterDropdownData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.content.id).subscribe(result => {
      this.amdTypeOptions = result["MasterData1"];
      this.PatientList = result["MasterData2"];
    });

  }
  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/EAPAmendments/Edit?RecordID=" + this.content.id).subscribe(result => {
       ;
      if (result["SUBMISSION_DATE"] != null && result["SUBMISSION_DATE"] != "") {
        var formd2 = this.datepipe.transform(result["SUBMISSION_DATE"], 'dd-MMM-yyyy');
        result["SUBMISSION_DATE"]=formd2;
      }
      this.amemdmentsForm.patchValue({
        ID: result["ID"],
        APPLICATION_ID: result["APPLICATION_ID"],
        TYPE: result["TYPE"],
        TITLE: result["TITLE"],
        PATIENT_ID: result["PATIENT_ID"],

        NOTES: result["NOTES"],
        STATUS: result["STATUS"],
      });
       ;

      if (this.amemdmentsForm.controls["STATUS"].value == '2') { // Edit mode
        this.amemdmentsForm.disable();
        this.heading = "View";
      }
    });

  }
  editRow() {
  }

  SaveAmendments() {
     ;
    if (this.validateControls() && this.extendedForm.validateControls()) {
      var formData = this.amemdmentsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      //if (formData["SUBMISSION_DATE"] != null && formData["SUBMISSION_DATE"] != "") {
      //  formData["SUBMISSION_DATE"] = new Date(formData["SUBMISSION_DATE"]);
      //  const ldate = new Date(formData["SUBMISSION_DATE"]);
      //  formData["STR_SUBMISSION_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      //}
      if (this.heading == "Add") {
        formData["ID"] = this.content.id;
        this.summaryService.Insert("api/EAPAmendments/Insert", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.SuccessBanner('Data has been inserted successfully.');
           // this.modalService.open(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });

              this.modalRef.close();
            });
        });
      }
      else {
        this.summaryService.Insert("api/EAPAmendments/Update", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.SuccessBanner('Data has been inserted successfully.');  //
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });

            this.modalRef.close();
          });
        });
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.amemdmentsForm.value;
    if (formData.TYPE === null || formData.TYPE === "") {
      $("#TYPE").addClass("ng-touched ng-invalid validate-error");
      $("#TYPE").removeClass("ng-untouched ng-valid");
      message += "Please select Type.<br/>";
      isValid = false;
    } else {
      $("#TYPE").addClass("ng-untouched ng-valid");
      $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.TITLE === null || formData.TITLE === "") {
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Title.<br/>";
      isValid = false;
    } else {
      $("#TITLE").addClass("ng-untouched ng-valid");
      $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
    }


    //if (formData.PATIENT_ID === null || formData.PATIENT_ID === "") {
    //  $("#PATIENT_ID").addClass("ng-touched ng-invalid validate-error");
    //  $("#PATIENT_ID").removeClass("ng-untouched ng-valid");
    //  message += "Please select Patient Name.<br/>";
    //  isValid = false;
    //} else {
    //  $("#PATIENT_ID").addClass("ng-untouched ng-valid");
    //  $("#PATIENT_ID").removeClass("ng-touched ng-invalid validate-error");
    //}
    //if (formData.SUBMISSION_DATE === null || formData.SUBMISSION_DATE === "") {
    //  $("#SUBMISSION_DATE").addClass("ng-touched ng-invalid validate-error");
    //  $("#SUBMISSION_DATE").removeClass("ng-untouched ng-valid");
    //  message += "Please select Submission Date.<br/>";
    //  isValid = false;
    //} else {
    //  $("#SUBMISSION_DATE").addClass("ng-untouched ng-valid");
    //  $("#SUBMISSION_DATE").removeClass("ng-touched ng-invalid validate-error");
    //}
    if (formData.NOTES === null || formData.NOTES === "") {
      $("#NOTES").addClass("ng-touched ng-invalid validate-error");
      $("#NOTES").removeClass("ng-untouched ng-valid");
      message += "Please enter Notes.<br/>";
      isValid = false;
    } else {
      $("#NOTES").addClass("ng-untouched ng-valid");
      $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
    }


    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }
  //SubmitRecord() {
  //  if (this.validateControls() && this.extendedForm.validateControls()) {
  //    var formData = this.amemdmentsForm.value;
  //    formData["APPLICATION_ID"] = this.ApplicationID;
  //    if (formData["SUBMISSION_DATE"] != null && formData["SUBMISSION_DATE"] != "") {
  //      formData["SUBMISSION_DATE"] = new Date(formData["SUBMISSION_DATE"]);
  //      const ldate = new Date(formData["SUBMISSION_DATE"]);
  //      formData["STR_SUBMISSION_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

  //    }

  //  this.summaryService.Insert("api/EAPAmendments/Update", formData).subscribe(result => {
  //    this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
  //      this.summaryService.UpdateStatus("api/EAPAmendments/UpdateStatus?RecordID=" + this.content.id).subscribe(result => {
  //        this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Record has been Submitted successfully.' } } });
  //
  //        this.modalRef.hide();
  //      });
  //    });
  //  });
  //  }
  //}

  SubmitRecord() {
     ;
    if (this.validateControls() && this.extendedForm.validateControls()) {
      var formData = this.amemdmentsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      formData["STATUS"] = 2;
      if (this.heading == "Add") {
        formData["ID"] = this.content.id;
        this.summaryService.Insert("api/EAPAmendments/Insert", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.SuccessBanner('Data has been inserted successfully.' );
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });

            this.modalRef.close();
          });
        });
      }
      else {
        this.summaryService.Insert("api/EAPAmendments/Update", formData).subscribe(result => {
          this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
            this.commonService.SuccessBanner('Data has been inserted successfully.' );
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been Updated successfully.' } } });

            this.modalRef.close();
          });
        });
      }
    }
  }

}
